import { groupJobTaskIndexes } from "./customerSuppliedTasks";
import { isCommentInvoiceLine } from "./commentInvoiceLines";

// Labels use the portal's exact classification, without copying invoice/private
// metadata or recalculating any saved prices.
export function buildJabLabelTaskGroups(items = [], orgId, catalog) {
  const groups = { tasks: [], jabMaterials: [], customerMaterials: [] };
  for (const group of groupJobTaskIndexes(items, orgId, catalog)) {
    groups[group.key] = group.indexes.map(index => {
      const item = items[index] || {};
      return {
        description: String(item.description || item.desc || ""),
        qty: item.qty,
        ...(isCommentInvoiceLine(item) ? { lineType: "comment", note: String(item.note || "") } : {})
      };
    });
  }
  return groups;
}
